import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AppThunk } from '../store'
import {
  postGoogleSync,
  postGoogleLink,
  postGoogleZendesk,
} from '../../apis/auth'
import { setErrors } from '../common/errorsSlice'
import {
  GoogleSyncResponse,
  GoogleCallbackUrl,
} from '../../types/auth'

export interface GoogleSyncState extends GoogleSyncResponse {
  isSucceeded: boolean | null
}

const initialState: GoogleSyncState = {
  login_url: "",
  isSucceeded: null,
}

const googleSyncSlice = createSlice({
  name: 'googleSync',
  initialState,
  reducers: {
    requestStart: (state) => state,
    postGoogleSyncSuccess: (state, action: PayloadAction<GoogleSyncResponse>) => {
      state.login_url = action.payload.login_url
      state.isSucceeded = true
      return state
    },
    postGoogleLinkSuccess: (state) => {
      state.isSucceeded = true
    },
    requestFailure: (state) => {
      state.isSucceeded = false
      return state
    },
  },
})

export const {
  requestStart,
  postGoogleSyncSuccess,
  postGoogleLinkSuccess,
  requestFailure,
} = googleSyncSlice.actions

export const googleSyncReducer = googleSyncSlice.reducer

export const createGoogleSync = (
  callback: (google: GoogleSyncState) => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  postGoogleSync()
    .then((result) => {
      dispatch(postGoogleSyncSuccess(result))
      callback(result)
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const createGoogleZendesk = (
  callback: (google: GoogleSyncState) => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  postGoogleZendesk()
    .then((result) => {
      dispatch(postGoogleSyncSuccess(result))
      callback(result)
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const createGoogleLink = (
  params: GoogleCallbackUrl,
  callback: (result: boolean) => void,
  errorCallback: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  postGoogleLink(params)
    .then(() => {
      dispatch(postGoogleLinkSuccess())
      callback(true)
    })
    .catch((error) => {
      dispatch(requestFailure())
      if (error.needResetToken) {
        dispatch(setErrors({
          status: error.status,
          needResetToken: false,
          errors: [],
        }))
      } else {
        dispatch(setErrors(error))
      }
      errorCallback()
    })
}
